import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { User } from 'src/app/calvin-emr-shared/models/user.model';
import { PageComponent } from 'src/app/calvin-emr-shared/page/page.component';
import { PatientService } from 'src/app/calvin-emr-shared/services/patient.service';
import { UserService } from 'src/app/calvin-emr-shared/services/user.service';
import { getUserFromSnapshot } from 'src/app/calvin-emr-shared/utils/user.util';
import { RouterOutlet } from '@angular/router';

/**
 * This component is used primarily for routing. It displays other pages
 * within the StudentsModule based on the URL through the <router-outlet> tag.
 */
@Component({
  selector: 'app-students-home-page',
  template: `<router-outlet></router-outlet>`,
  styles: [],
  standalone: true,
  imports: [RouterOutlet],
})
export class StudentsPageComponent extends PageComponent implements OnInit, OnDestroy {
  studentsSubscription?: Subscription;

  students: User[] = [];
  patients: Patient[] = [];

  constructor(
    public store: Store,
    public userService: UserService,
    public patientService: PatientService
  ) {
    super(store);
  }

  ngOnInit(): void { }

  /**
   * Unsubscribes from all subscriptions.
   */
  ngOnDestroy(): void {
    this.studentsSubscription?.unsubscribe();
    this.currentUserSub.unsubscribe();
  }

  /**
   * Retrieves all students one time.
   */
  fetchStudents() {
    this.startLoading();
    this.studentsSubscription = this.userService.getAllStudents().subscribe((res) => {
      this.students = res.docs.map((docSnapshot) => getUserFromSnapshot(docSnapshot));
      this.stopLoading();
    });
  }
}
